/**
 * TypeChip (UI-SPEC W7) — small text chip in the side-panel header.
 *
 * Read-only, no interaction. Type label uses the Label role (14px / 600).
 */
import { FormattedMessage } from "react-intl";
import type { AssetType } from "../../api/assets";

interface TypeChipProps {
  type: AssetType;
  "data-testid"?: string;
}

const LABEL_ID: Record<AssetType, string> = {
  manhole: "LABEL_TYPE_MANHOLE",
  catch_basin: "LABEL_TYPE_CATCH_BASIN",
};

export function TypeChip({ type, "data-testid": testId }: TypeChipProps) {
  return (
    <span
      data-testid={testId ?? `type-chip-${type}`}
      className="inline-flex items-center gap-1 ps-2 pe-2 h-6 rounded-full text-sm font-semibold bg-surface-raised text-on-surface ring-1 ring-divider"
    >
      <FormattedMessage id={LABEL_ID[type]} />
    </span>
  );
}
